import { render, staticRenderFns } from "./SeatChart.vue?vue&type=template&id=25cfed66&scoped=true"
import script from "./SeatChart.vue?vue&type=script&lang=ts"
export * from "./SeatChart.vue?vue&type=script&lang=ts"
import style0 from "./SeatChart.vue?vue&type=style&index=0&id=25cfed66&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cfed66",
  null
  
)

export default component.exports